export type DonationCurrency = 'ron' | 'eur' | 'usd' | 'gbp' | 'huf';

export interface DonationCurrencyConfig {
  label: string;
  presets: number[];
  min: number;
  max: number;
}

// Amounts are whole major units (lei, euros, forints…); HUF stays valid for
// Stripe because whole forints × 100 are always divisible by 100
export const DONATION_CURRENCIES: Record<DonationCurrency, DonationCurrencyConfig> = {
  ron: { label: 'RON', presets: [20, 50, 100, 200], min: 5, max: 50000 },
  eur: { label: 'EUR', presets: [5, 10, 25, 50], min: 2, max: 10000 },
  usd: { label: 'USD', presets: [5, 10, 25, 50], min: 2, max: 10000 },
  gbp: { label: 'GBP', presets: [5, 10, 20, 50], min: 2, max: 10000 },
  huf: { label: 'HUF', presets: [2000, 5000, 10000, 20000], min: 500, max: 5000000 },
};

export const isDonationCurrency = (value: unknown): value is DonationCurrency =>
  typeof value === 'string' && value in DONATION_CURRENCIES;

export const DONATION_COMMENT_MAX_LENGTH = 200;

// Memo line shown on invoice PDFs, in the invoice's language
export const donationCommentMemo = (currency: string | null | undefined, comment: string) =>
  `${currency === 'ron' ? 'Mesaj' : 'Message'}: ${comment}`;
